import type * as THREE from 'three'
import type { Vector3 } from 'three'
import { Vector2 } from 'three'
import type { Mesh } from '../../export'

export class InteractiveObject {
  target: THREE.Object3D
  name: string
  intersected: boolean
  wasIntersected = false
  distance: number
  point: Vector3 | null
  newClosestMesh!: Mesh
  constructor(target: THREE.Object3D, name: string) {
    this.target = target
    this.name = name
    this.intersected = false
    this.distance = 0
    this.point = null
  }
}

export class InteractiveEvent {
  type: string
  cancelBubble: boolean
  originalEvent: Event | null
  point: Vector3 | null
  newClosestMesh!: Mesh

  // Dummy default values
  coords: Vector2 = new Vector2(0, 0)
  distance = 0
  intersected = false

  constructor(type: string, originalEvent: Event | null = null) {
    this.cancelBubble = false
    this.type = type
    this.originalEvent = originalEvent
    this.point = null
  }

  stopPropagation() {
    this.cancelBubble = true
  }
}
